import React from 'react'

const StyledLgText = ({ children, fontColor }) => {
    return (
        <p className={`text-sm md:text-base lg:text-lg leading-relaxed font-normal ${fontColor}`}>{children}</p>
    )
}

export default StyledLgText
